import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SaveBoostInput_InputAdapter_instance2t8hzjm7o3gc6 as SaveBoostInput_InputAdapter_instance } from '../type/adapter/SaveBoostInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveBoostMutation_VariablesAdapterClass;
function SaveBoostMutation_VariablesAdapter() {
  if (SaveBoostMutation_VariablesAdapterClass === VOID) {
    class $ {
      q6s(writer, value, customScalarAdapters, withDefaultValues) {
        writer.k4e('input');
        obj(SaveBoostInput_InputAdapter_instance).t41(writer, customScalarAdapters, value.p6s_1);
      }
    }
    initMetadataForObject($, 'SaveBoostMutation_VariablesAdapter');
    SaveBoostMutation_VariablesAdapterClass = $;
  }
  return SaveBoostMutation_VariablesAdapterClass;
}
var SaveBoostMutation_VariablesAdapter_instance;
function SaveBoostMutation_VariablesAdapter_getInstance() {
  return SaveBoostMutation_VariablesAdapter_instance;
}
//region block: init
SaveBoostMutation_VariablesAdapter_instance = new (SaveBoostMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SaveBoostMutation_VariablesAdapter_instance as SaveBoostMutation_VariablesAdapter_instance2lm8atx218dgg,
};
//endregion

//# sourceMappingURL=SaveBoostMutation_VariablesAdapter.mjs.map
